import { useState, useEffect } from 'react';
import { usePWA } from '@/hooks/usePWA';
import { RippleButton } from '@/components/interactions';
import { Card } from '@/components/ui/card';
import { Download, X } from 'lucide-react';

export const InstallPrompt = () => {
  const { isInstallable, isInstalled, promptInstall } = usePWA();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const wasDismissed = localStorage.getItem('install-prompt-dismissed');
    if (wasDismissed === 'true') {
      setDismissed(true);
    }
  }, []);

  const handleInstall = async () => {
    const accepted = await promptInstall();
    if (accepted) {
      setDismissed(true);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('install-prompt-dismissed', 'true');
  };

  if (!isInstallable || isInstalled || dismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-20 left-4 right-4 z-40 animate-slide-up md:left-auto md:right-4 md:max-w-sm">
      <Card className="p-4 shadow-lg">
        <button
          onClick={handleDismiss}
          className="absolute top-2 right-2 text-muted-foreground hover:text-foreground"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-start gap-3 pr-6">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
            <Download className="w-5 h-5 text-primary" />
          </div>

          <div className="flex-1">
            <h3 className="font-semibold text-foreground text-sm mb-1">
              Install App
            </h3>
            <p className="text-xs text-muted-foreground mb-3">
              Add to home screen for quick access and offline use
            </p>

            <div className="flex gap-2">
              <RippleButton onClick={handleInstall} size="sm" className="flex-1">
                Install
              </RippleButton>
              <RippleButton onClick={handleDismiss} size="sm" variant="ghost">
                Not Now
              </RippleButton>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
